import { Flex, Icon, Text } from "@chakra-ui/react";

import ListIcon from "@/assets/svg/new-list-icon.svg";

const ModalListItem = ({ item, handler }) => {
  return (
    <Flex
      key={item?.id}
      align={"center"}
      columnGap={"12px"}
      h={"32px"}
      px={"10px"}
      cursor={"pointer"}
      onClick={() => handler(item?.id)}
      _hover={{ bg: "lightGreen2" }}
    >
      <Icon as={ListIcon} w={"16px"} h={"16px"} />
      <Flex align={"center"} justify={"space-between"} w={"100%"}>
        <Text>{item?.title}</Text>
        <Text
          color={"grey"}
          fontSize={"10px"}
          lineHeight={"1.35"}
          letterSpacing={"4%"}
          mt={"2px"}
        >
          {item?.entities?.length || 0}
        </Text>
      </Flex>
    </Flex>
  );
};

export default ModalListItem;
